import gql from 'graphql-tag';

export const queryMockExamAvailableExams = gql`
  query mockExamAvailableExams($roundCode: ID!, $locationCode: ID!) {
    mockExamAvailableExams(mockExamRoundCode: $roundCode, mockExamLocationCode: $locationCode) {
      id
      exams {
        id
        subjectCode
        subjectName
      }
    }
  }
`;

export const queryMockExamStudentExamCards = gql`
  query mockExamStudentExamCards($roundCode: ID!) {
    mockExamStudentExamCards(mockExamRoundCode: $roundCode) {
      id
      studentExamCards {
        id
        roundCode
        locationCode
        locationName
        subjectCode
        examId
        subjectName
        seat
        managedBy
      }
    }
  }
`;
